import React from 'react';
import RoutedTabs from 'src/components/routed-tabs';
import {Switch, Route, Redirect} from 'react-router-dom';
import UserDataFileUploader from 'src/views/admin/UserDataFileUploader';
import PublicResourceUploader from 'src/views/admin/PublicResourceUploader';

const tabs = [
  {label: 'Public Resource', path: '/public-resource'},
  {label: 'User Data', path: '/user-data'},
];

const FileUploader = (): React.ReactElement => (
  <div>
    <RoutedTabs tabs={tabs} className="text-center" />
    <Switch>
      <Route path="/admin/tools/upload-file/user-data" component={UserDataFileUploader} />
      <Route path="/admin/tools/upload-file/public-resource" component={PublicResourceUploader} />
      <Redirect path="*" to="/admin/tools/upload-file/public-resource" />
    </Switch>
  </div>
);

export default FileUploader;
